"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWrapper = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../../utils/theme");
exports.StyledWrapper = styled_components_1.default.div(__assign(__assign({}, theme_1.font), { background: theme_1.colors.white, boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.1)', boxSizing: 'border-box', height: '100%', padding: '0 20px 20px 20px', width: '100%' }));
//# sourceMappingURL=styles.js.map